<template lang="pug">
	b-form-group(:label="_field.label" :description="_field.help")
		b-input-group
			b-input-group-prepend(v-if="_field.icon")
				b-input-group-text
					i(:class='_field.icon')
			b-form-textarea(:value="value" :name="_field.name" v-bind="_field.attrs" @input.native="$emit('input', $event.target.value)" :state="_checkState(_field.name)")
			b-form-invalid-feedback {{ _invalidFeedback(_field.name) }}
</template>
<script>
	export default {
		name: 'w-input',
		props: ['value','_field','_checkState', '_invalidFeedback'],
	}
</script>
